export default [
    {
        title: '更多资讯',
        key: 'article',
        tag: false,
    },
    {
        title: '最新活动',
        key: 'activity',
        tag: true
    },
    {
        title: '最新话题',
        key: 'topic',
        tag: true
    },
    {
        title: '相关明星',
        key: 'star',
        type: 1
    },
]
